import { ROUTE_PATHS } from 'src/routes/_shared/routes.constants';

export function isNewEditor() {
  return window.location.pathname !== '/';
}

export function isUploadRoute() {
  return window.location.pathname.includes(ROUTE_PATHS.UPLOAD);
}
